export default __webpack_public_path__ + "static/media/SAS0240.34I-38840_-22808_0.99233cc1.jpg";